import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {AppComponent} from '../app.component';

import {ViewAdminsComponent} from '../view-admins/view-admins.component';
import {EditBrandComponent} from '../edit-brand/edit-brand.component';
import {SelectBrandComponent} from 'app/select-brand/select-brand.component';

import {MatDialog} from '@angular/material';

import swal from 'sweetalert2';
import {FileUploadService} from '../services/FileUploadService';
import {Router} from '@angular/router';

declare var $;

@Component({
    selector: 'app-brands',
    templateUrl: './brands.component.html',
    styleUrls: ['./brands.component.scss'],
    providers: [HttpService, NotificationService, FileUploadService]
})
export class BrandsComponent implements OnInit {

    public apiUrl = environment.apiUrl;

    public showAddModalBool = false;

    public addBrandData = {
        name: '',
        type: 'parent',
        image_path: '',
        parent_id: 0
    }

    public showType = 'pending';

    public brandOptionsToShow;

    public User_Details: any;
    public allBrands: any;
    public newBrand = {
        name: '',
        email: ''
    }

    public sortValue: string = '';
    public reverse: boolean = false;
    private allParentBrands;

    public currentPage = 1;

    // Server-side search term. Sent with every brands/get request so it composes
    // with the existing sort + pagination (the API filters before paginating).
    public searchValue: string = '';
    private searchTimer: any;

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
        public dialog: MatDialog,
        public fileUpload: FileUploadService,
        public router: Router
    ) {
    }

    editBrand(brand) {
        for (var i = 0; i < this.allBrands.length; i++) {
            this.allBrands[i].showOptions = false;
        }
        let dialogRef = this.dialog.open(EditBrandComponent, {
            width: '100vw',
            data: {brandDetails: brand}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedBrand) {

                }
            }

        });
    }

    createBrand() {
        this.http.makeRequestPost(['admin/user/brands/create', {
            token: this.User_Details.token,
            name: this.newBrand.name,
            email: this.newBrand.email
        }])
        .subscribe(
            (response) => {
                if (response.data) {
                    this.allBrands.push(response.data);
                    this.newBrand = {
                        name: '',
                        email: ''
                    }
                }
                if (response.error) {
                    this.notification.showNotification('Could not create the new brand', 'Error', 'error');
                }
            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.getAllBrands();
    }

    viewAdmins(brand) {
        for (var i = 0; i < this.allBrands.length; i++) {
            this.allBrands[i].showOptions = false;
        }
        let dialogRef = this.dialog.open(ViewAdminsComponent, {
            width: '100vw',
            height: '90vh',
            data: {brandDetails: brand}
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedBrand) {
                    for (var i = 0; i < this.allBrands.length; i++) {
                        if (this.allBrands[i].id == brand.id) {
                            this.allBrands[i] = result.changedBrand;
                        }
                    }
                }
            }

        });

    }

    getAllBrands(page = 1) {
        this.app.loading = true;
        this.http.makeRequestPost([`admin/user/brands/get?page=${page}`, {token: this.User_Details.token, search: this.searchValue}])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    if (response.data.data) {
                        console.log(response.data);
                        this.allBrands = response.data;
                    } else {
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }

                } else {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        )
    }

    deleteBrand(brand) {
        for (var i = 0; i < this.allBrands.length; i++) {
            this.allBrands[i].showOptions = false;
        }
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to delete this brand?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log(data);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/brands/delete', {token: this.User_Details.token, id: brand.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        console.log(response);
                        if (response.data) {
                            for (var i = 0; i < this.allBrands.length; i++) {
                                if (this.allBrands[i].id == brand.id) {
                                    this.allBrands[i] = response.data;
                                    this.notification.showNotification('The brand has been deleted.', 'Success', 'success');
                                }
                            }
                        } else {
                            if (response.error) {
                                this.notification.showNotification('Could not delete the brand.', 'Error', 'error');
                            }
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        console.log(error);
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    verifyBrand(brand) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to verify this brand?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log(data);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/brands/verify', {token: this.User_Details.token, id: brand.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        console.log(response);
                        if (response.data) {
                            for (var i = 0; i < this.allBrands.length; i++) {
                                if (this.allBrands[i].id == brand.id) {
                                    this.allBrands[i] = response.data;
                                    this.notification.showNotification('The brand has been verified.', 'Success', 'success');
                                }
                            }
                        } else {
                            if (response.error) {
                                this.notification.showNotification('Could not verify the brand.', 'Error', 'error');
                            }
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        console.log(error);
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    unVerifyBrand(brand) {
        swal({
            title: 'Confirmation',
            text: 'Are you sure you want to unverify this brand?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            buttonsStyling: false,
            imageUrl: 'assets/img/Popup_Squirrel.png',
            imageWidth: 100,
            showCloseButton: true,
            animation: false,
            confirmButtonClass: 'btn btn-orange btn-block btn-full input-block-level',
            cancelButtonClass: 'btn btn-orange-outline btn-block btn-full input-block-level',
            reverseButtons: true
        }).then((data) => {
            if (data.value) {
                console.log(data);
                this.app.loading = true;
                this.http.makeRequestPost(['admin/user/brands/unverify', {token: this.User_Details.token, id: brand.id}])
                .subscribe(
                    (response) => {
                        this.app.loading = false;
                        console.log(response);
                        if (response.data) {
                            for (var i = 0; i < this.allBrands.length; i++) {
                                if (this.allBrands[i].id == brand.id) {
                                    this.allBrands[i] = response.data;
                                    this.notification.showNotification('The brand has been unverified.', 'Success', 'success');
                                }
                            }
                        } else {
                            if (response.error) {
                                this.notification.showNotification('Could not unverify the brand.', 'Error', 'error');
                            }
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        console.log(error);
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            }

        })
    }

    onLinkClick(evt) {
        console.log(evt);
        if (evt.index == 0) {
            this.showType = 'pending';
        } else {
            this.showType = 'verified';
        }
    }

    checkShow(brand) {

    }

    toggleShowOptions(brand) {
        if (brand.showOptions == true) {
            brand.showOptions = false;
        } else {
            for (var i = 0; i < this.allBrands.length; i++) {
                this.allBrands[i].showOptions = false;
            }

            brand.showOptions = true;
        }

    }

    // setSelectedBrand(brand, option) {
    //     for (var i = 0; i < this.allBrands.length; i++) {
    //         if (this.allBrands[i].id == option) {
    //             brand.selected_brand = this.allBrands[i];
    //         }
    //     }

    //     this.app.loading = true;
    //     this.http.makeRequestPost(['app/user/brands/set_brand_parent_brand',
    //             {
    //                 id: brand.id,
    //                 parent_id: option
    //             }
    //         ]
    //     )
    //     .subscribe(
    //         (resp) => {
    //             this.app.loading = false;
    //             if (resp.data) {
    //                 for (var i = 0; i < this.allBrands.length; i++) {
    //                     if (this.allBrands[i].id == option) {
    //                         brand.selected_brand = this.allBrands[i];
    //                     }
    //                 }
    //                 this.notification.showNotification('The brand has been assigned a parent brand', 'Success', 'success');
    //             } else {
    //                 this.notification.showNotification('Could not assign the parent brand', 'Error', 'error');
    //             }
    //         },
    //         (error) => {
    //             this.app.loading = false;
    //             this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
    //         }
    //     )
    // }

    arrangeOptions(brand) {

        this.brandOptionsToShow = JSON.parse(JSON.stringify(this.allBrands));

        for (var i = 0; i < this.brandOptionsToShow.length; i++) {
            if (this.brandOptionsToShow[i].id == brand.id) {
                this.brandOptionsToShow.splice(i, 1);
            }
        }
    }

    toggleBrandParentOptions(brand) {
        if (brand.showParentOptions == true) {
            brand.showParentOptions = false;
        } else {
            for (var i = 0; i < this.allBrands.length; i++) {
                this.allBrands[i].showParentOptions = false;
            }

            brand.showParentOptions = true;
        }
    }

    setBrandOption(brand, option) {
        if (brand.is_parent == 1) {
            if (option == 'parent') {
                brand.is_parent = 1;
            } else {
                brand.is_parent = 0;
                this.setBrandAsChild(brand);
            }
        }

        if (brand.is_parent == 0) {
            if (option == 'parent') {
                brand.is_parent = 1;
                this.setBrandAsParent(brand)
            } else {
                brand.is_parent = 0;

            }
        }


        brand.showParentOptions = false;
    }

    setBrandAsParent(brand) {
        this.app.loading = true;
        this.http.makeRequestPost(['app/user/brands/set_brand_parent', {id: brand.id}])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.notification.showNotification('The brand has been set as a parent brand', 'Success', 'success');
                } else {
                    this.notification.showNotification('Could not set the brand as a parent brand', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    setBrandAsChild(brand) {
        this.app.loading = true;
        this.http.makeRequestPost(['app/user/brands/set_brand_child', {id: brand.id}])
        .subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.notification.showNotification('The brand has been set as a child brand', 'Success', 'success');
                } else {
                    this.notification.showNotification('Could not set the brand as a child brand', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    // checkShowBrand(brand, option) {
    //     if (brand.id == option.id) {
    //         return false;
    //     }

    //     if (option.parent_id != null) {
    //         return false;
    //     }

    //     return true;
    // }

    onDrop(event: any) {
        event.preventDefault();
        event.stopPropagation();
        console.log(event.dataTransfer.files);
        this.uploadFile(event.dataTransfer.files);
        // your code goes here after droping files or any
    }

    onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();

    }

    onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();

    }

    fileChange(event) {
        const selected = event.target.files && event.target.files[0];
        if (!this.fileUpload.isValidImageFile(selected)) {
            this.notification.showNotification('Please select an image file (JPG or PNG).', 'Invalid file', 'error');
            event.target.value = '';
            return;
        }
        this.uploadFile(event.target.files);
    }

    uploadFile(file) {
        console.log(file);
        this.app.loading = true;

        this.fileUpload.uploadFile('app/user/brands/upload_brand_image', file, {})
        .subscribe(
            (response) => {
                console.log(response);

                setTimeout(() => {

                    this.addBrandData.image_path = response.data;

                    this.app.loading = false;
                }, 1000);


            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        );
    }

    setAddBrandType(type, evt) {
        if (type == 'parent') {
            if (evt.checked == true) {
                this.addBrandData.type = 'parent'
            } else {
                this.addBrandData.type = 'child'
            }
        }

        if (type == 'child') {
            if (evt.checked == true) {
                this.addBrandData.type = 'child'
            } else {
                this.addBrandData.type = 'parent'
            }
        }
    }

    toggleAddModal() {
        if (this.showAddModalBool == true) {
            $('.wrapper').removeClass('lock-scroll');
        } else {
            $('.wrapper').addClass('lock-scroll');
        }
        this.showAddModalBool = !this.showAddModalBool;

        this.allParentBrands = JSON.parse(JSON.stringify(this.allBrands));

        for (var i = this.allParentBrands.length - 1; i >= 0; i--) {
            if (this.allParentBrands[i].is_parent == 0) {
                this.allParentBrands.splice(i, 1);
            }

        }
    }

    addBrand() {
        this.app.loading = true;
        console.log(this.allBrands);
        this.http.makeRequestPost(['app/user/brands/add_brand', {
            token: this.User_Details.token,
            name: this.addBrandData.name,
            type: this.addBrandData.type,
            image_path: this.addBrandData.image_path,
            parent_id: this.addBrandData.parent_id,
        }])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.allBrands.unshift(response.data);
                    console.log(this.allBrands);
                    this.toggleAddModal();
                    this.addBrandData = {
                        name: '',
                        type: 'parent',
                        image_path: '',
                        parent_id: 0
                    }

                }
                if (response.error) {
                    if (response.error.indexOf('Login session expired') > -1) {
                        this.notification.showNotification('Login session expired, please log in and try again', 'Error', 'error');
                        this.router.navigate(['/pages/login']);

                    } else {
                        this.notification.showNotification('Could not create the new brand', 'Error', 'error');
                    }

                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    dismissall() {
        for (var i = 0; i < this.allBrands.length; i++) {
            this.allBrands[i].showOptions = false;
        }
    }

    setBrandParent(brand) {
        for (var i = 0; i < this.allBrands.length; i++) {
            this.allBrands[i].showOptions = false;
        }
        let dialogRef = this.dialog.open(SelectBrandComponent, {
            width: '100vw',
            data: {
                brandDetails: brand,
                allBrands: this.allBrands
            }
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                if (result.changedBrand) {

                }
            }

        });
    }

    loadPage(event) {
        this.currentPage = event;
        this.getAllBrands(event);
    }

    // Debounced handler for the search box so we don't hit the API on every keystroke.
    onSearchInput() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => {
            this.onSearch();
        }, 350);
    }

    // Run the search: reset to page 1 and reload, preserving the active column sort
    // if there is one (so search + sort + pagination all work together).
    onSearch() {
        this.currentPage = 1;
        if (this.sortValue) {
            this.changeSortValue(this.sortValue, !this.reverse, 1);
        } else {
            this.getAllBrands(1);
        }
    }

    clearSearch() {
        if (this.searchValue === '') {
            return;
        }
        this.searchValue = '';
        this.onSearch();
    }

    changeSortValue(column, reverse, page = 1) {
        this.app.loading = true;
        this.http.makeRequestPost([`admin/user/brands/get?page=${page}`,
            {
                token: this.User_Details.token,
                sort_by: column,
                direction: reverse ? -1 : 1,
                search: this.searchValue,
            }])
        .subscribe(
            (response) => {
                this.currentPage = page;
                this.app.loading = false;
                if (response.data) {
                    if (response.data.data) {
                        // Set the list whatever the count — an empty result (e.g. a
                        // search with no matches) should clear the table, not error.
                        this.allBrands = response.data;
                    } else {
                        this.notification.showNotification('Could not get all users', 'Error', 'error');
                    }

                }
                if (response.error) {
                    this.notification.showNotification('Could not get all users', 'Error', 'error');
                }


            },
            (error) => {
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                this.app.loading = false;
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/app/brands/brands.component.ts